var map = {
	"./status-report-badge-1.svg": "d2b3",
	"./status-report-badge-2.svg": "ae04",
	"./status-report-badge-3.svg": "8e45",
	"./status-report-badge-4.svg": "4fe8",
	"./status-report-badge-5.svg": "601a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7905";